import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string';
import {
  GET_INCIDENTS_FOR_FORM,
  FLAG_GETTING_INCIDENTS_FOR_FORM,
  CLEAR_INCIDENTS_FOR_FORM,
} from '../types/supervision-control';
import { INCIDENT_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';

const flagGettingIncidentsForForm = (flag) => (dispatch) =>
  dispatch({ type: FLAG_GETTING_INCIDENTS_FOR_FORM, payload: flag });

const clearIncidentsForForm = () => (dispatch) =>
  dispatch({ type: CLEAR_INCIDENTS_FOR_FORM });

const getIncidentsForForm =
  ({ itineraryId, segmentId, incidentRecordType }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingIncidentsForForm(true));
      const query = QueryString.stringify({
        itineraryId,
        segmentId,
        incidentRecordType,
      });
      const url = `${INCIDENT_ENDPOINT}/itinerary/form?${query}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const payload = await response.json();
      dispatch({ type: GET_INCIDENTS_FOR_FORM, payload });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingIncidentsForForm(false));
    }
  };

const getIncidentsAgencyForm =
  () =>
  async (dispatch) => {
    try {
      dispatch(flagGettingIncidentsForForm(true));
      const url = `${INCIDENT_ENDPOINT}/agency/form`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const payload = await response.json();
      dispatch({ type: GET_INCIDENTS_FOR_FORM, payload });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingIncidentsForForm(false));
    }
  };

const getIncidentsAdministrativeForm =
  ({ incidentRecordType }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingIncidentsForForm(true));
      const query = QueryString.stringify({ incidentRecordType });
      const url = `${INCIDENT_ENDPOINT}/administrative/form?${query}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const payload = await response.json();
      dispatch({ type: GET_INCIDENTS_FOR_FORM, payload });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingIncidentsForForm(false));
    }
  };

export {
  getIncidentsForForm,
  clearIncidentsForForm,
  getIncidentsAgencyForm,
  getIncidentsAdministrativeForm,
};
